export default __webpack_public_path__ + "static/media/789711134391402536.01c386aa.png";